import { Component, Input, Directive, EventEmitter, Output, HostBinding, HostListener, inject } from '@angular/core';

@Component({
	selector: 'dropdown-menu',
	template: '<ng-content />',
	styleUrl: './dropdown-menu.component.scss',
	host: { class: 'dropdown-menu mat-elevation-z4' }
})
export class DropdownMenuComponent {
	@Input() title?: string;
	@Input() disabled = false;
}

@Component({
	selector: 'dropdown-menu li, dropdown-menu menu-item',
	template: '<a [class.active]="highlight" (click)="action.emit()"><ng-content /></a>',
	host: { class: 'nav-item' },
	imports: []
})
export class DropdownMenuItemComponent {
	@Input() highlight = false;
	@Input() disabled = false;
	@Output() action = new EventEmitter<void>();
}

@Directive({ selector: '[dropdown-parent]' })
export class DropdownParentDirective {

	@Output() onDropdownClosed = new EventEmitter<void>();

	private timer?: NodeJS.Timeout;
	private _openTrigger?: DropdownTriggerDirective;

	public set openTrigger(value: DropdownTriggerDirective | undefined) {
		if (this.timer) clearTimeout(this.timer);

		if (value) this._openTrigger = value;
		else this.timer = setTimeout(() => {
			this._openTrigger = undefined;
			this.onDropdownClosed.emit();
		}, 750);
	}
	public get openTrigger() {
		return this._openTrigger;
	}

	@HostListener('mouseleave') hideDropdown() { this.openTrigger = undefined; }
}


@Directive({ selector: '[dropdown-trigger]' })
export class DropdownTriggerDirective {
	private readonly parent = inject(DropdownParentDirective);
	@Output('dropdown-trigger') onTrigger = new EventEmitter<void>();
	@HostBinding('class.open') get open() { return this.parent.openTrigger == this; }
	@HostListener('mouseenter') openDropdown() {
		if (this.parent.openTrigger !== this) this.onTrigger.emit();
		this.parent.openTrigger = this;
	}
}

export const DropdownMenu = [
	DropdownMenuComponent,
	DropdownMenuItemComponent,
	DropdownParentDirective,
	DropdownTriggerDirective
];
